import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';

@Directive({
    selector: '[dmsInputRestrict]'
})
export class InputRestrictDirective implements OnInit {


    inputElement: HTMLElement;
    constructor(public el: ElementRef) {
        this.inputElement = el.nativeElement;
    }

    ngOnInit() {
        this.inputElement = this.el.nativeElement;
    }

    @HostListener('keydown', ['$event'])
    onKeyDown(e: KeyboardEvent) {
        if (this.isValidKey(e)) {
            return;
        }
        if (e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) {
            e.preventDefault();
        }
        if (e.shiftKey || (e.keyCode < 65 || e.keyCode > 90)) {
            e.preventDefault();
        }

        if (e.shiftKey || (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }

        if (e.keyCode === 187) {
            event.preventDefault();
        }
    }


    @HostListener('drop', ['$event'])
    onDrop(event: DragEvent) {
        event.preventDefault();
        const textData = event.dataTransfer.getData('text').replace(/\D/g, '');
        this.inputElement.focus();
        document.execCommand('insertText', false, textData);
    }

    isValidKey(e: KeyboardEvent) {
        if (
            [37, 38, 39, 40, 96, 46, 8, 9, 27, 13].indexOf(e.keyCode) !== -1 ||
            (e.keyCode >= 48 && e.keyCode <= 57) ||
            (e.keyCode >= 65 && e.keyCode <= 90) ||
            (e.keyCode >= 96 && e.keyCode <= 105)
        ) {
            return true;
        }
        return false;
    }

}
